export const StaticRoutes = {
  Home: "/",
  Bidding: "/bidding",
  TripBoard: "/trip-board",
  Seniority: "/seniority",
  UPSPricing: "/pricing/ups",
  ASPricing: "/pricing/alaska",
  AAPricing: "/pricing/american",
  Contact: "/contact",
  Login: "/login",
  Account: "/account",
  ConfirmEmail: "/account/ConfirmEmail",
  PasswordResetSent: "/password-reset"
};
